module.exports = __webpack_public_path__ + "media/graphics/no-cards-7721fd6a.svg";